<template>
    <div class="Invitation">
        <Header msg="邀请二维码"/>
        <Navbar :selected.sync="selected" :selecteData.sync="selecteData"/>

        <div class="Invitation-context" v-if="selecteData[selected].id === 2">
            <!-- <p class="text-yellow">扫一扫二维码，来当招生合伙人吧~</p> -->
            <img src="@/assets/recruit/invite_bg01@3x.png" alt="" class="code-bg"/>
            <p class="code-mycode ellipsis">{{sessionData.true_name || sessionData.nickname}}</p>
            <p class="code-mycode ellipsis" style="top:1.2rem">邀请您加入招生团队</p>
            <img :src="qrCode[1]" alt="" class="qrcode"/>
            <div class="code-bottom">
              <p>1.使用微信扫一扫二维码。</p>
              <p>2.填写你的姓名、手机号码。</p>
            </div>
        </div>
        <div class="Invitation-context" v-if="selecteData[selected].id === 1">
            <!-- <p class="text-yellow">扫一扫二维码，来当助理合伙人吧~</p> -->
            <img src="@/assets/recruit/invite_bg01@3x.png" alt="" class="code-bg"/>
            <p class="code-mycode ellipsis">{{sessionData.true_name || sessionData.nickname}}</p>
            <p class="code-mycode ellipsis" style="top:1.2rem">邀请您加入招生团队</p>
            <img :src="qrCode[0]" alt="" class="qrcode"/>
            <div class="code-bottom">
              <p>1.使用微信扫一扫二维码。</p>
              <p>2.填写你的姓名、手机号码。</p>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Navbar from '@/components/Navbar.vue';
import { getQrcode, CODE_URL, REQUEST_BASE } from '@/api';

export default {
    name: 'InvitationCode',
    components: {
      Header,
      Navbar,
    },
    data () {
      return {
        qrCode: ['', ''], // 二维码地址
        codeData: [{}, {}], // x
        selected: 0, // Navbar 索引
        selecteData: [{id: 1, name: '助理合伙人', num: 0}], // Navbar数据
        sessionData: {} // 临时数据 缓存
      }
    },
    watch:{
    },
    created() {
      let userData = JSON.parse(localStorage.getItem('cww_data'))
      this.getCode(userData.id, 1)
      // type:3 => 可展示助理合伙人二维码；type:4 => 可展示助理合伙人、	招生合伙人二维码；
      if (Number(this.$route.query.type) === 4) {
        this.selecteData.unshift({id: 2, name: '招生合伙人', num: 0});
        this.getCode(userData.id, 2);
      }
      this.sessionData = JSON.parse(sessionStorage.getItem('_sessionData'));
      if (this.sessionData && this.sessionData.RecruitIndex) this.sessionData = JSON.parse(this.sessionData.RecruitIndex);
    },
    
    methods: {
      // 获取二维码
      getCode(id, type) {
        let InvUrl = {url: `${REQUEST_BASE()}/InvitationPage?id=${id}&type=${type}`, type: type};
        getQrcode(InvUrl).then(res => {
          // this.qrCode[type - 1] = res._imgUrl
          this.qrCode.splice((type-1), 1, res._imgUrl);
        })
      }
    },
    watch: {
    }
}

</script>
<style lang='less' scoped>
.mint-header.is-fixed {
    z-index: 99;
}
.Invitation{
    min-height: 100vh;
    font-size: 0.15rem;
    .Navbar{
      position: fixed;
      top: 0.45rem;
      z-index: 9;
      max-width: 640px;
    }
    .Invitation-context{
        border-top: 0.45rem solid #F6F6FA;
        padding: 0.3rem 0 0;
        min-height: 100vh;
        background: white;
        position: relative;
        .code-bg{
            width: 3.17rem;
            height: 4.2rem;
            position: absolute;
            top:0.7rem;
            left: 50%;
            transform: translateX(-50%);
        }
        .code-mycode{
            color: #f44;
            font-size: 0.16rem;
            position: absolute;
            font-weight: bold;
            width: 2.8rem;
            top: 1rem;
            left: 50%;
            transform: translateX(-50%);
        }
        .qrcode{
            width: 2.5rem;
            height: 2.5rem;
            position: absolute;
            top: 1.5rem;
            left: 50%;
            transform: translateX(-50%);
        }
        .code-bottom{
            width: 2.4rem;
            text-align: left;
            line-height: 0.2rem;
            color: #666666;
            font-size: 0.14rem;
            position: absolute;
            top: 4.2rem;
            left: 50%;
            transform: translateX(-50%);
        }
    }
}
</style>